import * as React from 'react'
import { debounce } from 'lodash'
import { TransferPagination } from './TransferPagination'
import { observer } from 'mobx-react'
import { ILocation, TransferStatus } from '@getgreenline/homi-shared'
import { capitalizeFirstLetter } from '../../../../../utilities/helpers'
import { Input, Select, Button, Icon } from 'antd'

interface Props {
  pagination: TransferPagination
  locations: ILocation[]
  loadTransfers: () => void
}

export const StatusFilters = observer((props: Props) => {
  const { pagination, locations, loadTransfers } = props

  const { titleFilter, statusFilter, fromLocationIdFilter, toLocationIdFilter } =
    pagination.transferPaginationFilter

  const filterStatusOptions: TransferStatus[] = [
    TransferStatus.PENDING,
    TransferStatus.IN_PROGRESS,
    TransferStatus.COMPLETED,
    TransferStatus.CANCELLED,
  ]

  const onTitleFilterChange = debounce((search: string) => {
    pagination.setTitleFilter(search)
    loadTransfers()
  }, 500)

  return (
    <div className='white-rounded-container pb-0'>
      <Input
        placeholder='Title / ID'
        defaultValue={titleFilter}
        className='gr-filter-item gr-filter-gutter'
        addonBefore={<Icon type='search' />}
        onChange={(e) => onTitleFilterChange(e.target.value)}
      />

      <Select<number>
        placeholder='Source location'
        allowClear
        className='gr-filter-item gr-filter-gutter'
        value={fromLocationIdFilter}
        onChange={(locationId) => {
          pagination.setFromLocationIdFilter(locationId)
          loadTransfers()
        }}
      >
        {locations.map((location) => {
          console.log(location.name)
          return (
            <Select.Option key={location.id} value={location.id}>
              {location.name}
            </Select.Option>
          )
        })}
      </Select>

      <Select<number>
        placeholder='Target location'
        allowClear
        className='gr-filter-item gr-filter-gutter'
        value={toLocationIdFilter}
        onChange={(locationId) => {
          pagination.setToLocationIdFilter(locationId)
          loadTransfers()
        }}
      >
        {locations.map((location) => {
          return (
            <Select.Option key={location.id} value={location.id}>
              {location.name}
            </Select.Option>
          )
        })}
      </Select>

      <Select<TransferStatus>
        placeholder='Status'
        allowClear
        className='gr-filter-item gr-filter-gutter'
        value={statusFilter}
        onChange={(status) => {
          pagination.setStatusFilter(status)
          loadTransfers()
        }}
      >
        {filterStatusOptions.map((status) => {
          return (
            <Select.Option key={status} value={status}>
              {capitalizeFirstLetter(status === 'inProgress' ? 'In Progress' : status)}
            </Select.Option>
          )
        })}
      </Select>

      <Button
        onClick={() => {
          pagination.setOffset(0)
          loadTransfers()
        }}
        icon='reload'
      />
    </div>
  )
})
